<template>
    <div>
        <CompassFormItem
            :label="$t.__('common.labels.address')"
            :error="getErrorMsg"
            :orientation="orientation"
        >
            <CompassInput
                ref="jawgInput"
                v-model="query"
                :error="!!errorMsg"
                @input="$emit('input')"
                @update:value="handleUpdateValue"
            />
        </CompassFormItem>
        <CompassPopover
            :isVisible="isVisible"
            triggerRef="jawgInput"
            placement="bottom-start"
            :isTriggerWidth="true"
            @close="isVisible = false"
        >
            <div
                ref="autocompleteAddressResults"
                class="autocomplete-address__results typographies-paragraph-medium-regular"
            />
        </CompassPopover>
    </div>
</template>

<script>
import JawgJSLoader from '@jawg/js-loader';
import Env from 'Services/Env';
import { formatAddressForJawgForApi } from 'Helpers/addressHelpers';
import { debounce } from 'lodash';

export default {
    props: {
        errorMsg: {
            type: String,
            default: '',
        },
        orientation: {
            type: String,
            default: 'vertical',
        },
    },
    data() {
        return {
            jawgToken: Env.get('jawg').token,
            jawgLoader: null,
            query: '',
            isVisible: false,
            placesInput: null,
        };
    },
    computed: {
        getErrorMsg() {
            if (!this.errorMsg) {
                return '';
            }

            return this.query
                ? this.$t.__('document.DocFormSettingsDialog.AutocompleteAddress.invalid_address')
                : this.errorMsg;
        },
    },
    async mounted() {
        this.jawgLoader = new JawgJSLoader({ accessToken: this.jawgToken });
        const jawgPlaces = !window.JawgPlaces
            ? await this.jawgLoader.loadJawgPlaces()
            : window.JawgPlaces;

        this.placesInput = new jawgPlaces.Input({
            input: this.$refs.jawgInput.$refs.compassInput,
            noResultsMessage: this.$t.__('common.labels.no_result'),
            onFeatures: () => {
                this.isVisible = true;
            },
            onClick: (feature) => {
                this.isVisible = false;
                const address = formatAddressForJawgForApi(feature);
                this.$emit('update:address', address);
                this.query = address.label;
            },
            onClose: () => {
                this.isVisible = false;
            },
            resultContainer: this.$refs.autocompleteAddressResults,
        });
    },
    methods: {
        handleUpdateValue: debounce(async function (value) {
            this.query = value;
            if (value) {
                const featureCollection = await this.placesInput.search(value);
                featureCollection.features = featureCollection.features.filter(({ properties }) => {
                    return properties?.postalcode && properties?.locality;
                });
                this.placesInput.showResults(featureCollection);
            }
        }, 200),
    },
};
</script>

<style lang="scss" scoped>
.autocomplete-address__results {
    max-height: 312px;
    overflow-y: auto;
}
</style>
